document.addEventListener('DOMContentLoaded', () => {
  const openBtn = document.querySelector('[data-mobile-menu-toggle]');
  const closeBtn = document.querySelector('[data-mobile-menu-close]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const header = document.querySelector('.site-header');

  // Mobil menyu
  if (mobileMenu && openBtn) {
    const openMenu = () => mobileMenu.classList.add('mobile-nav--open');
    const closeMenu = () => mobileMenu.classList.remove('mobile-nav--open');

    openBtn.addEventListener('click', openMenu);
    mobileMenu.addEventListener('click', (e) => {
      if (e.target === mobileMenu) closeMenu();
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', closeMenu);
    }
  }

  // Scroll olunca header shadow
  if (header) {
    const onScroll = () => {
      if (window.scrollY > 8) {
        header.classList.add('site-header--scrolled');
      } else {
        header.classList.remove('site-header--scrolled');
      }
    };

    onScroll();
    window.addEventListener('scroll', onScroll);
  }
});


document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-mobile-menu-toggle]');
  var drawer = document.querySelector('[data-mobile-menu]');
  var closeBtn = document.querySelector('[data-mobile-menu-close]');

  if (!toggle || !drawer) return;

  function openMenu() {
    drawer.classList.add('mobile-nav--open');
    document.body.classList.add('has-mobile-nav-open');
  }

  function closeMenu() {
    drawer.classList.remove('mobile-nav--open');
    document.body.classList.remove('has-mobile-nav-open');
  }

  toggle.addEventListener('click', function () {
    if (drawer.classList.contains('mobile-nav--open')) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', closeMenu);
  }

  // Overlay click ilə bağlamaq üçün
  drawer.addEventListener('click', function (e) {
    if (e.target === drawer) {
      closeMenu();
    }
  });
});
